<script>
import { layoutMethods } from "@/state/helpers";
import { menuItems } from "./horizontal-menu";

export default {
  data() {
    return {
      menuItems: menuItems
    };
  },
  methods: {
    ...layoutMethods,

    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling;
      if (nextEl && !nextEl.classList.contains("show")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.add("show");
      } else if (nextEl) {
        nextEl.classList.remove("show");
      }
      return false;
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    change_layout(layout) {
      return this.changeLayoutType({ layoutType: layout });
    },
    topbarLight() {
      document.body.setAttribute("data-topbar", "light");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedWidth() {
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-topbar", "light");
      document.body.setAttribute("data-topbar", "dark");
    }
  },
  mounted() {
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }
    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
        }
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("active");
          var childAnchor = parent3.querySelector(".has-dropdown");
          if (childAnchor) childAnchor.classList.add("active");
        }

        const parent4 = parent3.parentElement;
        if (parent4) parent4.classList.add("active");
        const parent5 = parent4.parentElement;
        if (parent5) parent5.classList.add("active");
      }
    }
  },
};
</script>

<template>
  <div class="topnav">
    <div class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link to="/" class="nav-link side-nav-link-ref">
                  <i class="ri-dashboard-line"></i>
                  <span>Dashboard</span>
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link to="/admins" class="nav-link side-nav-link-ref" v-if="$can('access_admin')">
                  <i class="ri-admin-line"></i>
                  <span>Admins</span>
              </router-link>
            </li> -->
            <li class="nav-item">
              <router-link to="/users" class="nav-link side-nav-link-ref" >
                  <i class="ri-group-line"></i>
                  <span>Users</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/answers" class="nav-link side-nav-link-ref" >
                  <i class="ri-question-answer-line"></i>
                  <span>Answers</span>
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link to="/agent-transfer" class="nav-link side-nav-link-ref" v-if="$can('access_agent_transfer')">
                  <i class="ri-chat-smile-2-line"></i>
                  <span>Agent Transfer</span>
              </router-link>
            </li>
            <li class="nav-item">
                <router-link to="/chat-history" class="nav-link side-nav-link-ref" >
                    <i class="ri-message-3-line"></i>
                    <span>Chat History</span>
                </router-link>
            </li> -->
            <!-- <li class="nav-item">
                <router-link to="/unampped-responses" class="nav-link side-nav-link-ref" >
                    <i class="ri-file-list-3-line"></i>
                    <span>Unampped Responses</span>
                </router-link>
            </li> -->
            <!-- <li class="nav-item">
                <router-link to="/time-slot" class="nav-link side-nav-link-ref" >
                    <i class="ri-map-pin-time-line"></i>
                    <span>Time Slots</span>
                </router-link>
            </li> -->
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>